import { useMutation, useQueryClient } from '@tanstack/react-query';
import { putSecretSetting, removeSecretSetting } from '../services/dealerSecretSettings';
import { dealerConfigSettingKeys } from './useDealerConfigSettingsQuery';
import { dealerSecretSettingKeys } from './useDealerSecretSettingQuery';

export const useDealerSecretSettingMutations = (dealerId: string, key: string) => {
    const queryClient = useQueryClient();

    const invalidate = async () => {
        await Promise.all([
            queryClient.invalidateQueries({ queryKey: dealerSecretSettingKeys.all }),
            queryClient.invalidateQueries({ queryKey: dealerConfigSettingKeys.all }),
        ]);
    };

    const put = useMutation({
        mutationFn: (secret: string) => putSecretSetting(dealerId, key, secret),
        gcTime: 0,
        onSuccess: invalidate,
    });

    const remove = useMutation({
        mutationFn: () => removeSecretSetting(dealerId, key),
        onSuccess: invalidate,
    });

    return { put, remove };
};
